module.exports = __webpack_public_path__ + "sports-news_icon.svg?9bf847b060c0b20d3c3397c321f91c5f";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/sports-news_icon.svg
// module id = 1067
// module chunks = 15